<link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css" rel="stylesheet">

<div class="sidebar" [ngClass]="{ 'collapsed': !(isSidebarOpen$ | async) }">
  <div class="sidebar-content">
    <div class="sidebar-logo text-center w-100">
      <img src="assets/login-image.png" alt="Logo" class="img-fluid" />
    </div>
    <ul class="nav w-100 px-3 ">
      <li *ngFor="let menu of menus$ | async" class="nav-item my-2">
        <div class="menu-item d-flex justify-content-between align-items-center p-2 rounded"
          (click)="menu.submenus ? toggleSubmenu(menu) : navigateTo(menu)">
          <i class="menu-icon me-2" [class]="menu.icon"></i>
          <span class="form-label-sm">{{ menu.title }}</span>
          <i *ngIf="menu.submenus" class="submenu-toggle ms-auto px-5" [class]="menu.collapsed ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
        </div>
        <ul *ngIf="menu.submenus && !menu.collapsed" class="nav flex-column ms-4 mt-2">
          <li *ngFor="let submenu of menu.submenus" class="nav-item">
            <a [routerLink]="submenu.route" class="nav-link text-white form-label-sm">
              <i class="submenu-icon me-2" [class]="submenu.icon"></i>
              {{ submenu.title }}
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>